// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"a9817ea0","621":"89893386","743":"6c1dd0ce"}[chunkId] + ".chunk.js";
};